import { cva } from 'class-variance-authority';

const logoVariants = cva('core:fill-current', {
  variants: {
    size: {
      sm: 'core:h-[22px] core:w-[70px]',
      md: 'core:h-[31px] core:w-[100px]',
      lg: 'core:h-[43px] core:w-[140px]',
      xl: 'core:h-[55px] core:w-[180px]',
      xxl: 'core:h-[65px] core:w-[210px]',
    },
    style: {
      default: 'core:!w-fit',
      isIcon: '',
    },
  },
});

export default logoVariants;
